import { Center, Spinner, Stack, Text } from '@chakra-ui/react'

interface LoadingStateProps {
  message?: string
}

export function LoadingState({ message = 'Loading...' }: LoadingStateProps) {
  return (
    <Center minH="200px">
      <Stack align="center" gap={4}>
        <Spinner />
        <Text color="fg.muted">{message}</Text>
      </Stack>
    </Center>
  )
}
